module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e2"
    }
  }, [_c('b', [_vm._v("Introduction ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e184212"
    }
  }, [_vm._v("DO GHOSTS LURK in the twilight, waiting to remind us that they have unfinished business to conduct, scores to settle, or wrongs to right? Or are spirits merely the work of our wild imaginings and superstitions?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e185512"
    }
  }, [_vm._v("Perhaps what we call ghosts have messages to impart before they are able to leave this material plane of existence . . . and perhaps they only need for someone to hear those messages before they find peace at last.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e186912"
    }
  }, [_vm._v("No matter who you are or where you live, chances are that at one time or another you will be brushed by the wings of the unearthly. You may feel the sudden chill of goose bumps or the hairs rising on your neck as you hurry from a dark room toward the light.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e188412"
    }
  }, [_vm._v("Even hardened investigators have been quite literally spooked. A physical response to fear cannot be controlled once the adrenaline courses through the blood and the heart starts to race. One can either stand or run, and the urge to run is hardwired into our bodies.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e190112"
    }
  }, [_vm._v("The mere thought of an apparition, ghost, or spirit is disturbing, because by definition such an entity is a remnant, a fragment of a soul desperately trying to move forward but trapped in a prison woven from its own dark dreams of violence, pain, and betrayal.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e191612"
    }
  }, [_vm._v("Perhaps some stay on the earthly plane for love, but if paranormal literature tells us anything, we know that haunted sites are places in which some human drama or tragedy has occurred, and the revenants that remain have their own agenda.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e193112"
    }
  }, [_vm._v("Ghosts are part of all human cultures, and the questions surrounding them are the same whether they were asked 5,000 years ago or just yesterday: Are ghosts real? Can they hurt us? Why do they seem to linger in some places?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e195113"
    }
  }, [_c('i', [_vm._v("The Everything")]), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_vm._v("®")])]), _c('i', [_vm._v(" Ghost Hunting Book ")]), _vm._v("addresses many of these questions and attempts to answer some of them. Whether any aspect of human consciousness survives beyond the death of the body is one of the most fundamental and universal mysteries. It has been a source of curiosity since the dawn of time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e197813"
    }
  }, [_vm._v("Do you have questions about the reality of ghosts and hauntings? Have you had experiences too strange and unbelievable to share— even with your closest friends? If so, this book has been written with you in mind.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e199813"
    }
  }, [_vm._v("Do you have a more skeptical nature? Are you only able to accept what you hear with your own ears or see with your own eyes? This book is written for you as well.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e200913"
    }
  }, [_vm._v("Armed with a need for answers, today’s ghost hunters are committed to stripping away any ambiguity from the equation of the supernatural. They are men and women on a mission to discover the hard evidence necessary to prove—or, ironically, disprove—the existence of spirits. A minority of these individuals are on a very different mission—their goal is to prove that all this talk of ghosts is hokum, and that all things that go bump in the night can be naturally explained. "), _c('i', [_vm._v("The Everything")]), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_vm._v("®")])]), _c('i', [_vm._v(" Ghost ")]), _c('i', [_vm._v("Hunting Book ")]), _vm._v("presents both sides of the mystery.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a066e08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Elli_9781605507057_epub_c11_r1.vue
// module id = 87
// module chunks = 0